<template>
  <div class="service-list">

    <!-- 普通样式 -->
    <div class="normal-service-list">
      <div class="service-item" v-for="(service, index) in normalServiceList" :key="index" @mouseenter="trackHeatMap($event, service)" @click="onClick(service)">
        <mouse-hover-wrapper>
          <div class="service">
            <image-hover
            :default-src="service.defaultImage"
            :hover-src="service.hoverImage"
            ></image-hover>
            {{ service.name }}
          </div>

          <!-- popover -->
          <template #popover v-if="service.popover">
            <components :is="service.popover"></components>
          </template>
        </mouse-hover-wrapper>
      </div>
    </div>


    <!-- 热线样式 -->
    <div class="hotline-service-list">
      <div class="service-item" v-for="(service, index) in hotLineServiceList" :key="index" @click="onClick(service)">
        <mouse-hover-wrapper>
          <div class="hotline">
            <div class="hotline-icon">
              <img :src="service.imgKey && peerCSData && peerCSData[service.imgKey] ? peerCSData[service.imgKey] : service.defaultImage" width="44" alt="">
            </div>
            <span>{{ service.name }}</span>
          </div>

          <template #popover v-if="service.popover">
            <components :is="service.popover" @openExcluive="showExcluiveDialog = true"></components>
          </template>
        </mouse-hover-wrapper>
      </div>
    </div>

    <!-- 因为popover会设置opacity等属性，导致如何弹窗放里面会显示不出来 -->
    <exclusive-service-dialog :visible.sync="showExcluiveDialog"></exclusive-service-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import sensorsdata from 'sa-sdk-javascript';
import ImageHover from './components/image-hover';
import MouseHoverWrapper from './components/mouse-hover-wrapper';
import ExclusiveServiceDialog from '../dialog/exclusive-service-dialog/exclusive-service-dialog';


export default {
  props: {
    serviceList: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    ImageHover,
    MouseHoverWrapper,
    ExclusiveServiceDialog,
  },
  data() {
    return {
      showExcluiveDialog: false,
    };
  },
  computed: {
    ...mapState('user', [
      'peerCSData',
    ]),
    normalServiceList() {
      return this.serviceList.filter(service => service.type !== 'hotline');
    },
    hotLineServiceList() {
      return this.serviceList.filter(service => service.type === 'hotline');
    },
  },
  methods: {
    trackHeatMap(e, service) {
      sensorsdata.quick('trackHeatMap', e.target);
    },
    onClick(service) {
      if (service.clickHandler && typeof service.clickHandler === 'function') {
        service.clickHandler();
      }

      console.log('dssadsadsa', service);

      // 在线咨询需要显示弹窗
      if (service.name === '在线咨询') {
        this.showExcluiveDialog = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.normal-service-list {
  background: #FFFFFF;
  box-shadow: 0px 4px 12px 0px rgba(30,43,61,0.1);
  border-radius: 28px;
  border: 1px solid #E9EEF2;
  padding: 12px 5px 20px 5px;
  .service-item {
    margin-top: 16px;
    &:first-child {
      margin-top: 0;
    }
  }
  .service {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #2F333D;
    line-height: 12px;
    cursor: pointer;
    &:hover {
      color: #599FFF;
    }
    /deep/ img {
      width: 44px;
      height: 44px;
      margin-bottom: 2px;
    }
  }
}

.hotline-service-list {
  .service-item {
    margin-top: 16px;
    &:hover {
      .hotline {
        position: relative;
        overflow: hidden;
        &::after {
          content: '';
          width: 100%;
          height: 100%;
          background-color: rgba(0,0,0,0.15);
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
    .hotline {
      background: linear-gradient( 180deg, #4083FF 0%, #599FFF 100%);
      box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.1);
      border-radius: 28px;
      border: 1px solid #E9EEF2;
      padding: 6px 6px 16px 6px;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .hotline-icon {
        width: 44px;
        height: 44px;
        background: #FFFFFF;
        border-radius: 50%;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
      span {
        writing-mode: vertical-lr;
        text-orientation: upright;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/service-list/service-list.vue